/**
 * Development-only diagnostic logging gate.
 * Production (and test) builds stay silent unless a test override is set.
 */

let override: boolean | null = null

export function setDevelopmentOnlyLoggingOverrideForTests(value: boolean | null): void {
  override = value
}

export function isDevelopmentOnlyLoggingEnabled(): boolean {
  if (override != null) return override
  return process.env.NODE_ENV === "development"
}
